import React from "react";
import { useTranslation } from "react-i18next";
import { CampaignKey } from "src/utils/constants";
import { getTime } from "../layouts/AskDatatram/ChatHandler";
import { Message } from "../layouts/AskDatatram/ChatInterface";

interface CustomCampaignFormProps {
  selectedCampaign: CampaignKey | null;
  setSelectedCampaign: (value: CampaignKey) => void;
  selectedSubCampaign: string | null;
  setSelectedSubCampaign: (value: string) => void;
  onAutoCorrectChange: (e: React.ChangeEvent<HTMLInputElement>, setter: (val: string) => void) => void;
  onProceed: (campaign: CampaignKey, subCampaign: string) => void;
  setQuery: React.Dispatch<React.SetStateAction<Message[]>>;
}

export const CustomCampaignForm: React.FC<CustomCampaignFormProps> = ({
  selectedCampaign,
  setSelectedCampaign,
  selectedSubCampaign,
  setSelectedSubCampaign,
  onAutoCorrectChange,
  onProceed,
  setQuery,
}) => {
  const { t } = useTranslation();

  const handleProceed = () => {
    if (!selectedCampaign || !selectedSubCampaign) {
      const botMessage: Message = {
        sender: "bot",
        text: t("chatbot.customCampaignForm.fillBothFieldsWarning"),
        timestamp: getTime(),
        type: "botQuestion",
      };
      setQuery(prev => [...prev, botMessage]);
      return;
    }

    onProceed(selectedCampaign, selectedSubCampaign);
  };

  return (
    <div className="promptbox-container" style={{ width: "80%" }}>
      <p className="promptbox-subtitle">{t("chatbot.customCampaignForm.title")}</p>

      <div className="promptbox-form-section">
        <label className="promptbox-subtitle">
          {t("chatbot.customCampaignForm.campaignNameLabel")} <span className="required-star">*</span>
        </label>
        <input
          type="text"
          className="promptbox-input"
          placeholder={t("chatbot.customCampaignForm.campaignNamePlaceholder")}
          onChange={e => setSelectedCampaign(e.target.value as CampaignKey)}
        />
      </div>

      <div className="promptbox-form-section">
        <label className="promptbox-subtitle">
          {t("chatbot.customCampaignForm.subCampaignNameLabel")} <span className="required-star">*</span>
        </label>
        <input
          type="text"
          className="promptbox-input"
          placeholder={t("chatbot.customCampaignForm.subCampaignNamePlaceholder")}
          onChange={e => onAutoCorrectChange(e, setSelectedSubCampaign)}
        />
      </div>

      <div className="category-actions">
        <button className="proceed-button" onClick={handleProceed}>
          {t("chatbot.customCampaignForm.proceedToPrompt")}
        </button>
      </div>
    </div>
  );
};

